import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/observable/of';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { catchError, tap } from 'rxjs/operators';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { SendTestProfile } from './send-test-profile.model';
import { CognitoService } from '../../services/cognito/cognito.service';
import { AwsSignerService } from '../../services/aws-signer/aws-signer.service';
import { Encoder } from '../../utils/encoder';
import { GENDERS } from '../../services/constants/gender-list';
import { ENVIRONMENTS } from '../../services/constants/environment-list';
import { USERIDENTIFIERTYPES } from '../../services/constants/user-identifier-type-list';
import { USERIDENTIFIERSUBTYPES } from '../../services/constants/user-identifier-sub-type-list';
import { Client } from '../client/client.model';

@Injectable()
export class SendTestProfileService {
  constructor(private http: HttpClient,
    private cognitoService: CognitoService,
    private awsSignerService: AwsSignerService) {
  }

  requestRealTime(sendTestProfile: SendTestProfile,apiKey:string): Observable<any> {
    sendTestProfile = this.cleanPostBody(sendTestProfile);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-api-key': apiKey
      })
    };

    return this.http.post<SendTestProfile>(this.getUrl(), sendTestProfile, httpOptions);
  }

  getClientById(campaignId): Observable<any> {
    const encodedId = Encoder.encode(campaignId);
    const awsHeaders = this.awsSignerService.getAwsHeader(`${this.getClientUrl()}?campaignId=${encodedId}`, 'GET');

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': awsHeaders['Authorization'],
        'X-Amz-Date': awsHeaders['X-Amz-Date'],
        'x-amz-security-token': awsHeaders['x-amz-security-token'],
        'x-api-key': environment.cesAPI.apiKey
      })
    };

    return this.http.get<Client>(`${this.getClientUrl()}?campaignId=${encodedId}`, httpOptions)
      .pipe(catchError(err => this.handleError(err)));
  }

  getGenderList(): string[] {
    return GENDERS;
  }

  getEnvironmentList(): string[] {
    return ENVIRONMENTS;
  }

  getUserIdentifierTypeList(): string[] {
    return USERIDENTIFIERTYPES;
  }

  getUserIdentifierSubTypeList(): string[] {
    return USERIDENTIFIERSUBTYPES;
  }

  private cleanPostBody(sendTestProfile: Object) {
    for (var propName in sendTestProfile) {
      if (sendTestProfile[propName] === null || sendTestProfile[propName] === undefined) {
        delete sendTestProfile[propName];
      }
    }
    return sendTestProfile;
  }

  private getUrl() {
    return `https://${environment.publicHost}/v2/datamart/collect`;
  }

  private getClientUrl() {
    return `${localStorage.getItem('region-api')}/v1/datamart/manage/client`;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error && error.error.message === 'The security token included in the request is expired') {
      this.cognitoService.logout();
      return;
    }
    if (error.error instanceof ErrorEvent) {
      // A campaign-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an ErrorObservable with a user-facing error message
    return new ErrorObservable(
      'Something bad happened. Please try again later.');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/send-test-profile/send-test-profile.service.ts